import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PAGE_TEXT } from '../../../constants/system-pages.constants';

@Component({
  selector: 'app-page-not-found',
  imports: [],
  templateUrl: './page-not-found.html',
  styleUrl: './page-not-found.scss',
})
export class PageNotFound {
  protected readonly text = PAGE_TEXT.pageNotFound;
  private router = inject(Router);

  goHome(): void {
    this.router.navigate(['/']);
  }

}